import { createAction, handleActions } from "redux-actions"
import { apiGet, apiPut, apiPost, apiDelete } from "../utils/apiConnector"
import { alertTypes, showMessage } from "./alerts"
import { discountApi, addItemsApi } from "../config/apiUrls"
import { forEachObjIndexed } from "ramda"
import { buildRefreshParameters } from "./tabularData/common"

const defaultState = {
  data: [],
  totalCount: 0,
  filters: [],
  currentPage: 1,
  totalPages: 1,
  searchQuery: null,
  sortedBy: null,
  sortedAsc: true,
  pendingRequests: 0,
  startDate: new Date(),
  endDate: new Date(),
}

const getDiscounts = createAction("GET_DISCOUNTS")

const reducers = handleActions(
  {
    [getDiscounts]: (state, { payload }) => ({
      ...state,
      data: [...payload],
      totalCount: payload.length,
    }),
  },
  defaultState,
)
export default reducers

export function getData() {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    apiGet(discountApi, buildRefreshParameters(storeId, defaultState))
      .onOk((res) => {
        dispatch(getDiscounts(res.data.response.discounts))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function editDiscounts(editedData) {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    forEachObjIndexed((data, id) => {
      apiPut(discountApi + "/" + storeId + "/" + id, data)
        .onOk((res) => {
          dispatch(getData())
          dispatch(
            showMessage("Акция успешно отредактирована", alertTypes.success),
          )
        })
        .useDefaultErrorHandlers(dispatch)
        .startSingle()
    }, editedData)
  }
}

export function createDiscount(createdData) {
  return (dispatch, getState) => {
    apiPost(discountApi, createdData)
      .onOk((res) => {
        dispatch(getData())
        dispatch(showMessage("Акция успешно создана", alertTypes.success))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function deleteDiscount(deleteIds) {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    deleteIds.map((discountId) => {
      apiDelete(discountApi, { discountId, storeId })
        .onOk(() => {
          dispatch(getData())
          dispatch(showMessage("Акция успешно удалена", alertTypes.success))
        })
        .useDefaultErrorHandlers(dispatch)
        .start()
    })
  }
}

export function deleteItems(deleteIds) {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    let stocks = []
    deleteIds.map((itemId) => {
      stocks.push(itemId)
    })
    const data = {
      storeId,
      stocks,
      discountId: window.clickId,
    }
    apiPut(addItemsApi, data)
      .onOk(() => {
        dispatch(getData())
        dispatch(showMessage("Товар успешно удален", alertTypes.success))
      })
      .useDefaultErrorHandlers(dispatch)
      .start()
  }
}

export function addItemsToDiscount(createdData) {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    const data = {
      ...createdData,
      storeId,
    }
    apiPost(addItemsApi, data)
      .onOk(() => {
        dispatch(showMessage("Товар добавлен в акцию", alertTypes.success))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}
